import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"new-modal-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"51\" height=\"50\" fill=\"none\" viewBox=\"0 0 51 50\"><path fill=\"#fff\" d=\"M45.34 33.854a1.48 1.48 0 0 1-.556-2.04c2.908-4.95 3.68-10.716 2.177-16.237a1.49 1.49 0 0 1 1.074-1.83c.81-.213 1.643.26 1.86 1.057 1.714 6.29.832 12.863-2.48 18.503a1.534 1.534 0 0 1-2.075.547ZM9.392 13.452a1.48 1.48 0 0 1-.556-2.04c3.313-5.64 8.662-9.676 15.061-11.36a1.522 1.522 0 0 1 1.861 1.055 1.491 1.491 0 0 1-1.074 1.83c-5.617 1.477-10.31 5.017-13.218 9.968a1.534 1.534 0 0 1-2.074.547Zm4.558 33.043c-3.626-2.059-4.872-6.632-2.779-10.197a1.534 1.534 0 0 1 2.075-.547 1.48 1.48 0 0 1 .556 2.04c-1.257 2.14-.51 4.883 1.667 6.118 2.176 1.235 4.967.5 6.224-1.64a1.533 1.533 0 0 1 2.074-.546 1.48 1.48 0 0 1 .556 2.04c-2.093 3.564-6.746 4.79-10.372 2.732Z\"></path><path fill=\"#fff\" d=\"M31.455 49.534 2.521 33.112c-1.692-.96-2.274-3.095-1.297-4.759a3.54 3.54 0 0 1 2.42-1.683c3.968-.702 7.38-3.059 9.383-6.47l2.823-4.807c3.908-6.654 12.593-8.942 19.362-5.1 6.769 3.842 9.096 12.38 5.188 19.034l-2.823 4.806a13.137 13.137 0 0 0-1.018 11.202 3.432 3.432 0 0 1-.263 2.924c-.977 1.663-3.148 2.235-4.84 1.275Zm2.239-36.655c-5.32-3.019-12.143-1.221-15.214 4.007l-2.822 4.806c-2.451 4.174-6.626 7.059-11.451 7.913a.506.506 0 0 0-.353.241.499.499 0 0 0 .186.68l28.934 16.422a.517.517 0 0 0 .691-.182.483.483 0 0 0 .038-.415 16.075 16.075 0 0 1 1.244-13.71l2.823-4.807c3.07-5.228 1.242-11.936-4.077-14.955Z\"></path><path fill=\"#fff\" d=\"M33.694 12.879a1.48 1.48 0 0 1-.557-2.039l3.038-5.171a1.534 1.534 0 0 1 2.074-.547 1.48 1.48 0 0 1 .556 2.04l-3.037 5.171a1.533 1.533 0 0 1-2.075.546Z\"></path></svg></div><div class=\"new-modal-header\"> Добавить подписку </div>", 2)
const _hoisted_3 = { class: "new-modal-text margin-bottom-min" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "new-modal-erroralert margin-bottom-min"
}
const _hoisted_7 = {
  key: 1,
  class: "margin-bottom-min flat-form"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flat-form__label" }, " E-mail: ", -1 /* HOISTED */)
const _hoisted_9 = { class: "custom-checkbox mb10" }
const _hoisted_10 = ["for"]
const _hoisted_11 = ["id", "onUpdate:modelValue"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_13 = {
  key: 2,
  class: "margin-bottom-min flat-form"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flat-form__label" }, " Telegram: ", -1 /* HOISTED */)
const _hoisted_15 = { class: "custom-checkbox mb10" }
const _hoisted_16 = ["for"]
const _hoisted_17 = ["id", "onUpdate:modelValue"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_19 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" Вы можете указать дополнительные способы оповещения. "),
      _hoisted_4,
      _createTextVNode(" Сейчас настраивается: "),
      _createElementVNode("strong", null, _toDisplayString(this.subscribe.previewText) + " " + _toDisplayString(this.subscribe.entityName) + " для модуля \"" + _toDisplayString(this.subscribe.moduleTitle) + "\"", 1 /* TEXT */),
      _createTextVNode("."),
      _hoisted_5,
      _createTextVNode(" В дальнейшем вы сможете управлять (настраивать и удалять) вашими подписками в Личном кабинете в разделе \"Мои подписки\". ")
    ]),
    ($data.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(this.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (this.subscribe.subscribeChannels.email !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.subscribe.subscribeChannels.email, (channel) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", {
                  for: channel.address
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: channel.address,
                    "onUpdate:modelValue": ($event: any) => ((channel.needToBeChecked) = $event),
                    type: "checkbox"
                  }, null, 8 /* PROPS */, _hoisted_11), [
                    [_vModelCheckbox, channel.needToBeChecked]
                  ]),
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(channel.address), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_10)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (this.subscribe.subscribeChannels.telegram !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.subscribe.subscribeChannels.telegram, (channel) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", {
                  for: channel.address
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: channel.address,
                    "onUpdate:modelValue": ($event: any) => ((channel.needToBeChecked) = $event),
                    type: "checkbox"
                  }, null, 8 /* PROPS */, _hoisted_17), [
                    [_vModelCheckbox, channel.needToBeChecked]
                  ]),
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(channel.address), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_16)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: _normalizeClass([{'button-loading': this.loading}, "button button-primary"]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.save && $options.save(...args)))
      }, "Да, подключить", 2 /* CLASS */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}